// Failing-first stub (task 4.1): position interpolation between the two most recent
// tick-stamped samples (design D10, PROTOCOL §2, UI.md §8). Pure — never extrapolates
// past the newest received tick; the renderer clamps to it instead.

export interface TickSample {
  tick: number;
  position: readonly [number, number];
}

/**
 * Interpolates a position for `renderTick` between the two bracketing samples `prev`
 * and `next` (`prev.tick <= next.tick`). Clamps to `prev` before it starts and to
 * `next` once `renderTick` reaches or passes it — the renderer MUST NOT extrapolate
 * beyond the newest tick.
 */
export function interpolatePosition(
  prev: TickSample,
  next: TickSample,
  renderTick: number,
): [number, number] {
  if (renderTick <= prev.tick) {
    return [prev.position[0], prev.position[1]];
  }
  if (renderTick >= next.tick) {
    // Never extrapolate past the newest received tick — clamp to it instead.
    return [next.position[0], next.position[1]];
  }
  const span = next.tick - prev.tick;
  const t = (renderTick - prev.tick) / span;
  return [
    prev.position[0] + (next.position[0] - prev.position[0]) * t,
    prev.position[1] + (next.position[1] - prev.position[1]) * t,
  ];
}
